export enum AppConfigNames {
  twoFactorAuthConfig = "twoFactorAuthConfig",
  appRestrictionConfig = "appRestrictionConfig",
  telegramBotConfig = "telegramBotConfig",
  appVersionConfig = "appVersion",
}

type BaseAppConfig = {
  id: string;
  enabled: boolean;

  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
};

export type AppConfig = BaseAppConfig &
  (
    | {
        name: AppConfigNames.appRestrictionConfig;
        data: AppConfigTwoFactor;
      }
    | {
        name: AppConfigNames.twoFactorAuthConfig;
        data: AppConfigIpWhiteList;
      }
    | {
        name: AppConfigNames.appVersionConfig;
        data: AppConfigAppVersion;
      }
  );

export type AppConfigAppVersion = {
  app: string;
};

export type AppConfigTwoFactor = {
  shouldApplyAdmin: boolean;
};

export type AppConfigIpWhiteList = {
  ipWhiteList: string[];
};
